import { PostBoxPageComponent } from './pages/post-box-page/post-box-page.component';

export const POSTBOX_WEB_ROUTES = [
  { path: '', component: PostBoxPageComponent },
  {
    path: 'tickets',
    loadChildren: () => import('@zero/tickets/feature-tickets/web').then((m) => m.TICKETS_WEB_ROUTES),
  },
];
